module.exports = __webpack_public_path__ + "media/images/championship__iconPickTeam--plain-608f98c37de8129df2bcf5ed3ec8603c.png";